export default __webpack_public_path__ + "static/media/51t.d886184d.jpg";